import { useCallback } from 'react'
import { dispatch } from './dispatch'

export const useEventDispatch = <T extends keyof WindowEventMap>(name: T) =>
  useCallback(
    (data?: Parameters<typeof dispatch<T>>[1]) => dispatch(name, data),
    [name]
  )
